import React from 'react';
import { RefreshCw, Clock, Sparkles } from 'lucide-react';
import Reveal from './Reveal';
import CountUp from './CountUp';

/**
 * StatsSection
 * Three credibility stats with count-up animation.
 * Numbers animate only when scrolled into view.
 */
const StatsSection = () => {
  const stats = [
    {
      icon: RefreshCw,
      end: 3,
      suffix: '',
      label: 'Revisions Included',
      note: 'Up to three free revisions, depending on your collection, to fine-tune your presentation.',
    },
    {
      icon: Clock,
      end: 48,
      suffix: 'hrs',
      label: 'Average Preview Delivery',
      note: 'Receive your first preview within 48 hours of us receiving your photos and videos.',
    },
    {
      icon: Sparkles,
      end: 100,
      suffix: '%',
      label: 'Professionally Hand Edited',
      note: 'Every cinematic presentation is handcrafted by our editors, never AI-generated or automated.',
    },
  ];

  return (
    <section className="py-24 bg-black relative overflow-hidden" data-testid="stats-section">
      {/* Fine gold divider ornament */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />

      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 max-w-5xl mx-auto">
          {stats.map((s, idx) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.label} delay={idx + 1} className="text-center">
                <div className="mx-auto w-14 h-14 rounded-full border border-amber-500/30 bg-amber-500/5 flex items-center justify-center mb-6">
                  <Icon size={24} className="text-amber-400" strokeWidth={1.5} />
                </div>
                <div className="text-5xl md:text-6xl font-bold text-white tracking-tight">
                  <CountUp end={s.end} suffix={s.suffix} />
                </div>
                <div className="mt-3 text-white font-medium tracking-wide">
                  {s.label}
                </div>
                <div className="mt-1 text-sm text-gray-500">
                  {s.note}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />
    </section>
  );
};

export default StatsSection;
